import { ENTITY_PRIORITY, ENTITY_RENDER_ORDER } from '@/editor/constant/entity';
import { pixelRatio2d } from '@/editor/math/const';
import { globalStores } from '@/editor/stores';
import { EEntityType } from '@/editor/types';
import { EContainerType } from '@/editor/types/entity';
import { clientPosToWorldPos } from '@/editor/utils';
import * as THREE from 'three';
import BaseModel2d from '../BaseModel2d';

const material = new THREE.MeshBasicMaterial({
  color: 0xff0000,
  transparent: true,
  opacity: 0,
  side: THREE.DoubleSide,
  depthTest: false
});

export class AreaDimensionTextInfoModel extends BaseModel2d {
  private _labelEl: HTMLElement;
  private _shapeMesh: THREE.Mesh;

  constructor({ labelEl, entityId }: { labelEl: HTMLElement; entityId: string }) {
    super();

    this._labelEl = labelEl;
    this._shapeMesh = new THREE.Mesh(this._createGeometry(), material);
    this._modelGroup.add(this._shapeMesh);
    this.setDisplayOrder(ENTITY_RENDER_ORDER.textInfo);

    this._modelGroup.userData.type = EEntityType.AreaDimension;
    this._modelGroup.userData.entityId = entityId;
    this._modelGroup.userData.priority = ENTITY_PRIORITY.textInfo;
    this._modelGroup.userData.containerType = EContainerType.entity;
    this._modelGroup.userData.isTextInfo = true;
    globalStores.editorStateStore.sceneInfo.scene2d.intersectableGroup.add(this._modelGroup);
  }

  public update() {
    const geometry = this._createGeometry();
    this._shapeMesh.geometry.dispose();
    this._shapeMesh.geometry = geometry ?? new THREE.BufferGeometry();
  }

  private _createGeometry() {
    const {
      renderer,
      scene2d: { camera }
    } = globalStores.editorStateStore.sceneInfo;
    const rect = this._labelEl.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) {
      return undefined;
    }

    const points = [
      clientPosToWorldPos({ x: rect.left, y: rect.bottom }, camera, renderer),
      clientPosToWorldPos({ x: rect.left, y: rect.top }, camera, renderer),
      clientPosToWorldPos({ x: rect.right, y: rect.top }, camera, renderer),
      clientPosToWorldPos({ x: rect.right, y: rect.bottom }, camera, renderer)
    ].map((pos) => new THREE.Vector2(pos.x / pixelRatio2d, pos.y / pixelRatio2d));

    return new THREE.ShapeGeometry(new THREE.Shape(points));
  }
}
